import { IGeo } from '../types/geo';
import { IGeoForMobileSiteSchema } from 'shared/repositories/search-engine/entities/geo/GeoForMobileSiteSchema';
import { IAddressDetailSchema } from 'shared/repositories/search-engine/entities/geo/AddressDetailSchema';

const addressToString = (data: IAddressDetailSchema[]): string => {
  return data.map(({ value }) => value).join(', ');
};

export const prepareGeo = ({ regionId, undergrounds, address, title }: IGeoForMobileSiteSchema): IGeo => {
  return {
    regionId,
    undergrounds,
    title,
    address: addressToString(address),
  };
};
